import { Component, ElementRef, Input, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NoteDataModel } from '../../../../models/notes/note-data.model';
import { EnumValidValueItemModel } from '../../../../models/enum/enum-valid-value-item.model';
import { TdoNoteFilterModel } from '../models/tdo-note-filter.model';
import { NoteCategoryDataModel } from '../../../../models/notes/note-category-data.model';
import { NoteTypeDataModel } from '../../../../models/notes/note-type-data.model';
import { Subscription } from 'rxjs';
import { NotesService } from '../../../../services/notes.service';
import { MessagingService } from '../../../../services/messaging.service';
import { StaticDataService } from '../../../../services/static-data.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { UiService } from '../../../../services/ui.service';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { Globals } from '../../../../globals';
import { TdoNoteQueryModel } from '../models/tdo-note-query.model';
import { MessagingConstants } from '../../../../models/MessagingConstants';
import { TdoNoteAssociatedObject, TdoNoteSaveModel } from '../models/tdo-note-save-model';
import { TdoUserConfigurationModel } from '../../../../models/configuration/user/tdo-user-configuration.model';
import { TdoNotesMultiselectMenuComponent } from '../tdo-notes-multiselect-menu/tdo-notes-multiselect-menu.component';
import { NoteGroupDescriptionModel } from '../../../../models/notes/note-group-description.model';
import { _testNotesGlobals } from '../../../../modules/notes/models/Notes.models';
import { Constants } from '../../../../constants';
import { TdoNoteBuilderComponent } from '../../tdo-note-builder/tdo-note-builder.component';
import { NoteGroupDataModel } from '../../../../models/notes/note-group-data.model';
import { TdoMacroNotesComponent } from '../../tdo-macro-notes/tdo-macro-notes.component';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { LandingPageService } from '../../../../services/landing-page.service';
import { PatientCaseViewDataModel } from '../../../../models/patient/patient-case-view-data.model';
import { MatSelectChange } from '@angular/material/select';
import { TextFieldModule } from '@angular/cdk/text-field';
import { DialogService } from 'src/app/services/dialog.service';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";


@Component({
  selector: 'app-tdo-notes-expanded',
  templateUrl: './tdo-notes-expanded.component.html',
  styleUrls: ['./tdo-notes-expanded.component.scss']
})
export class TdoNotesExpandedComponent implements OnInit, OnDestroy {
  @ViewChild('categoryDropdown') categoryDropdown: TdoNotesMultiselectMenuComponent;
  @ViewChild('typeDropdown') typeDropdown: TdoNotesMultiselectMenuComponent;

  @Input() listenToNoteQueryEvents: boolean = true;

  @Input() PatientID: string;
  @Input() CaseID: string;
  @Input() PatientName: string;
  @Input() NoteGroupId: string;
  @Input() ParentObjectName: string;
  @Input() ObjectId: string;

  @Input() categoryFilters: any[] = [];
  @Input() filteredMode: boolean = false;
  @Input() showAllFilter: any = { displayValue: 'Show all', selected: true };
  @Input() isDockedLeft = false;

  isMinimized = false;
  isShowModuleSpecificNotes = true;

  isShowAllCases: boolean = false;
  messagingSubscription: any;
  hideFilterButton: boolean = false;
  isLoading: boolean = true;
  deleteMode: boolean = false;
  hideFilters: boolean = true;
  notes: NoteDataModel[] = [];
  alertNotes: NoteDataModel[] = [];
  filteredNotes: NoteDataModel[] = [];

  objectsRelatedToPatient: NoteGroupDescriptionModel[] = [];
  selectedRelatedObjects: NoteGroupDescriptionModel[] = [];
  selectedTypes: string[];
  isShowSettings;

  storedUser;

  notesCategories: EnumValidValueItemModel[] = [];
  notesTypes: EnumValidValueItemModel[] = [];

  // Filter
  //////////////////////////////////////////////////////////////////////////////
  storedNoteFilterSettings: TdoNoteFilterModel;
  private allCategoryModel: NoteCategoryDataModel;
  private allTypeModel: NoteTypeDataModel;

  private isInitialized: boolean;
  private timeoutInstanceId: string;
  private subscriptions: Subscription[] = [];
  cases: PatientCaseViewDataModel[] = [];
  selectedCase: PatientCaseViewDataModel;

  allCase: PatientCaseViewDataModel = new PatientCaseViewDataModel();

  currentCaseId: string;
  patientId: string;
  patientCaseId: string;

  constructor(
    private notesGlobals: _testNotesGlobals,
    private notesService: NotesService,
    private messagingService: MessagingService,
    private el: ElementRef,
    private staticDataService: StaticDataService,
    private dialog: MatDialog,
    public uiService: UiService,
    private router: Router,
    public globals: Globals,
    private landingPageService: LandingPageService,
    private dialogService: DialogService,
    private activeRoute: ActivatedRoute,
    private dialogRef: MatDialogRef<TdoNotesExpandedComponent>,
    @Inject(MAT_DIALOG_DATA) public data: NoteDataModel
  ) {

    this.allCase.Description = 'All cases for patient';
    this.allCase.PatientCaseId = '*';
    this.allCategoryModel = new NoteCategoryDataModel();
    const categoryAllEnum = new EnumValidValueItemModel();
    categoryAllEnum.ValidValueItemId = 'storedCategoryAll';
    categoryAllEnum.ItemDisplayValue = 'Show All Categories';
    this.allCategoryModel.enumNoteCategory = categoryAllEnum;
    this.allCategoryModel.enumNoteCategoryID = categoryAllEnum.ValidValueItemId;

    this.allTypeModel = new NoteTypeDataModel();
    const typeAllEnum = new EnumValidValueItemModel();
    typeAllEnum.ValidValueItemId = 'storedTypeAll';
    typeAllEnum.ItemDisplayValue = 'Show All Types';
    this.allTypeModel.enumNoteType = typeAllEnum;
    this.allTypeModel.enumNoteTypeID = typeAllEnum.ValidValueItemId;
    this.storedUser = JSON.parse(localStorage.getItem('storedUser'));

    const storedFilterSettings = localStorage.getItem('noteStandaloneFilterSettings');
    if (storedFilterSettings) {
      this.storedNoteFilterSettings = JSON.parse(storedFilterSettings) as TdoNoteFilterModel;
    } else {
      this.storedNoteFilterSettings = new TdoNoteFilterModel();
      this.storedNoteFilterSettings.notesCategories.push(this.allCategoryModel);
      this.storedNoteFilterSettings.notesTypes.push(this.allTypeModel);
      this.storedNoteFilterSettings.isFullView = false;
      this.storedNoteFilterSettings.isCondensedView = true;
      this.storedNoteFilterSettings.isShowModifiedOn = false;
      this.storedNoteFilterSettings.isShowModifiedBy = false;
    }

    const sub = this.router.events.subscribe((data) => {
      if (data instanceof NavigationStart) {
        this.handleRouteChange(data);
      }
    });

    this.subscriptions.push(sub);

    this.patientId = this.globals.currentPatientId;
    this.patientCaseId = this.globals.currentPatientCaseId;
    this.activeRoute.queryParams.subscribe((res) => {
      if (res && res.patientId) {
        this.patientId = res.patientId;
      }

      if (res && res.patientCaseId) {
        this.patientCaseId = res.patientCaseId;
      }
    });
  }

  ngOnDestroy(): void {
    for (const sub of this.subscriptions) {
      sub.unsubscribe();
    }
  }

  onChangeNotesDock(dockSide: string) {
    if (dockSide === 'left') {
      this.uiService.isNotesOnLeft = true;
    } else {
      this.uiService.isNotesOnLeft = false;
    }
  }

  saveFilterSettings() {
    localStorage.setItem('noteStandaloneFilterSettings', JSON.stringify(this.storedNoteFilterSettings));
  }

  ngOnInit() {
    this.currentCaseId = this.patientCaseId;
    this.landingPageService.getPatientsCases4Landing(this.patientId).subscribe((data) => {
      this.cases = data;
      this.cases.unshift(this.allCase);
    });

    // Timeout added so that the @HostListener event responsible for closing when clicking outside
    // does not fire from the icon click itself.
    setTimeout(() => {
      this.isInitialized = true;
    }, 0.1);

    const model = new TdoNoteQueryModel();
    model.patientId = this.patientId;
    model.objectId = this.currentCaseId;

    if (this.staticDataService.validValueItems && this.staticDataService.validValueItems.length > 0) {
      this.notesCategories = this.staticDataService.getValidValueItemsByValidValueName('enumNoteCategory');
      this.notesTypes = this.staticDataService.getValidValueItemsByValidValueName('enumNoteType');
      this.getNotes(model);
      this.getAlertNotes();
    } else {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.notesCategories = this.staticDataService.getValidValueItemsByValidValueName('enumNoteCategory');
          this.notesTypes = this.staticDataService.getValidValueItemsByValidValueName('enumNoteType');
          this.getNotes(model);
          this.getAlertNotes();
        }
      });
    }
 }

  onOkClick() {
    this.dialogRef.close(this.data);
  }

  sortNotes() {
    this.notes = this.notes.sort((a, b) => {
      const d1 = new Date(a.xauditModifiedOn);
      const d2 = new Date(b.xauditModifiedOn);
      if (d1 > d2) {
        return -1;
      } else if (d2 > d1) {
        return 1;
      } else {
        return 0;
      }
    });
  }

  filterNotes() {
    if (this.storedNoteFilterSettings.notesCategories.length === 1 && this.storedNoteFilterSettings.notesTypes.length === 1
      && this.storedNoteFilterSettings.notesCategories[0].enumNoteCategoryID === this.allCategoryModel.enumNoteCategoryID && this.storedNoteFilterSettings.notesTypes[0].enumNoteTypeID === this.allTypeModel.enumNoteTypeID) {
      // Category and type filters set to all
      this.filteredNotes = this.notes;
    } else {
      this.filteredNotes = [];
      if (this.storedNoteFilterSettings.notesCategories[0].enumNoteCategoryID === this.allCategoryModel.enumNoteCategoryID) {
        this.filteredNotes = this.notes.filter(p => {
          const d = p.dataNoteTypes.find(e => this.storedNoteFilterSettings.notesTypes.map(h => h.enumNoteTypeID).includes(e.enumNoteTypeID));
          if (d) {
            return p;
          }
        });
      } else if (this.storedNoteFilterSettings.notesTypes[0].enumNoteTypeID === this.allTypeModel.enumNoteTypeID) {
        this.filteredNotes = this.notes.filter(p => {
          const d = p.dataNoteCategories.find(e => this.storedNoteFilterSettings.notesCategories.map(h => h.enumNoteCategoryID).includes(e.enumNoteCategoryID));
          if (d) {
            return p;
          }
        });
      } else {
        this.filteredNotes = this.notes.filter(p => {
          const d = p.dataNoteTypes.find(e => this.storedNoteFilterSettings.notesTypes.map(h => h.enumNoteTypeID).includes(e.enumNoteTypeID));
          if (d) {
            return p;
          }
        });
        this.filteredNotes = this.notes.filter(p => {
          const d = p.dataNoteCategories.find(e => this.storedNoteFilterSettings.notesCategories.map(h => h.enumNoteCategoryID).includes(e.enumNoteCategoryID));
          if (d) {
            return p;
          }
        });
      }
    }
  }

  setupCategoryFilters() {
    this.categoryFilters = [];
    /*this.dataNoteGroups.forEach(noteGroup => {
      noteGroup.display = true;
    });*/
    this.notesCategories.forEach(cat => {
      this.categoryFilters.push({
        displayValue: cat.ItemDisplayValue,
        selected: true,
      });
    });
  }

  getAlertNotes() {
    this.notesService.getAlertNotes(this.patientId).subscribe((alertRes) => {
      this.alertNotes = alertRes;
    });
  }

  getNotes(model: TdoNoteQueryModel) {
    if (this.isShowAllCases) {
      // show all
      this.getNotesAll(model);
    }
    else {
      // show by current case
      this.getNotesForPatientCase();
    }
  }

  getNotesAll(model: TdoNoteQueryModel) {
    this.isLoading = true;

    this.notesService.getNotes(model).subscribe((res) => {
      this.notes = res;
      this.sortNotes();
      this.filterNotes();
      this.isLoading = false;
      this.messagingService.sendComponentMessage(MessagingConstants.NOTES_FILTER_READY, {
        // no need for params
      });
    });
  }

  getNotesForPatientCase() {
    this.isLoading = true;

    this.notesService.getNotesForPatientCase(this.currentCaseId).subscribe((res) => {
      this.notes = res;
      this.sortNotes();
      this.filterNotes();
      this.isLoading = false;
      this.messagingService.sendComponentMessage(MessagingConstants.NOTES_FILTER_READY, {
        // no need for params
      });
    });
  }

  saveDataNote(model: TdoNoteSaveModel) {
    this.notesService.saveNote(model).subscribe((res) => {
      model.dataNote = res;
      let retModel = this.notes.findIndex(p => p.NoteId === model.dataNote.NoteId);
      if (retModel > -1) {
        this.notes[retModel] = res;
      } else {
        retModel = this.notes.findIndex(p => p.NoteId === undefined);
        if (retModel > -1) {
          this.notes[retModel] = res;
        } else {
          this.notes.unshift(res);
        }
      }
      this.filterNotes();
    });
  }

  onCloseClick(): void {
    this.messagingService.sendComponentMessage('Toggle-Notes-Display', { display: false });
  }

  onSettingsClick() {
    this.isShowSettings = !this.isShowSettings;
  }

  onEmergencyInformationClick() {
    this.storedNoteFilterSettings.isShowAlertNotes = !this.storedNoteFilterSettings.isShowAlertNotes;
    this.saveFilterSettings();
  }

  onFilterClickOutside() {
    if (this.isShowSettings) {
      this.isShowSettings = false;
    }
  }

  onAddNoteClick() {
    const newDataNote = new NoteDataModel();
    newDataNote.Note = '';
    newDataNote.xauditCreatedOn = new Date();
    newDataNote.xauditModifiedOn = new Date();
    newDataNote.xauditCreatedByUser = new TdoUserConfigurationModel();
    newDataNote.xauditModifiedByUser = new TdoUserConfigurationModel();
    const userNameArray = this.storedUser.fullname.split(' ');
    newDataNote.xauditCreatedByUser.FirstName = userNameArray[0];
    newDataNote.xauditCreatedByUser.LastName = userNameArray[1];
    newDataNote.xauditModifiedByUser.FirstName = userNameArray[0];
    newDataNote.xauditModifiedByUser.LastName = userNameArray[1];
    // this.notes.push(newDataNote);
    this.filteredNotes.unshift(newDataNote);
  }

  onNoteInput(event: string, noteData: NoteDataModel) {
    const model = new TdoNoteSaveModel();
    model.text = noteData.Note;
    model.patientId = this.patientId;

    const associatedObjects: TdoNoteAssociatedObject[] = [];
    const newAssociatedObjectCase = new TdoNoteAssociatedObject();
    // parentObjectName is the table to associate / group this with.
    newAssociatedObjectCase.parentObjectName = 'dataPatientCase';
    // objectId is the primary key of the parentObjectName table.
    newAssociatedObjectCase.objectId = this.patientCaseId;
    associatedObjects.push(newAssociatedObjectCase);

    model.associatedObjects = associatedObjects;
    model.dataNote = noteData;

    if (!noteData.NoteId) {
      model.text = noteData.Note;
    }
    this.saveDataNote(model);
  }

  onCategoryDropdownSelectionComplete(items: NoteCategoryDataModel[], noteData: NoteDataModel) {
    noteData.dataNoteCategories = items;
    const model = new TdoNoteSaveModel();
    model.text = noteData.Note;
    model.patientId = this.patientId;

    const associatedObjects = [];
    const newAssociatedObjectCase = new TdoNoteAssociatedObject();
    newAssociatedObjectCase.objectId = this.patientCaseId;
    newAssociatedObjectCase.parentObjectName = 'dataPatientCase';
    associatedObjects.push(newAssociatedObjectCase);

    model.associatedObjects = associatedObjects;
    model.dataNote = noteData;
    if (!noteData.NoteId) {
      model.text = noteData.Note;
    }
    this.saveDataNote(model);
  }

  onTypeDropdownSelectionComplete(items: NoteTypeDataModel[], noteData: NoteDataModel) {
    noteData.dataNoteTypes = items;
    const model = new TdoNoteSaveModel();
    model.text = noteData.Note;
    model.patientId = this.patientId;

    const associatedObjects = [];
    const newAssociatedObjectCase = new TdoNoteAssociatedObject();
    newAssociatedObjectCase.objectId = this.patientCaseId;
    newAssociatedObjectCase.parentObjectName = 'dataPatientCase';
    associatedObjects.push(newAssociatedObjectCase);

    model.associatedObjects = associatedObjects;
    model.dataNote = noteData;
    if (!noteData.NoteId) {
      model.text = noteData.Note;
    }
    this.saveDataNote(model);
  }

  getDate(date: Date) {
    const date1 = new Date(date);
    let hours = date1.getHours();
    let demarcation = 'AM';
    if (hours > 12) {
      hours -= 12;
      demarcation = 'PM';
    } else {
      if (hours === 0) {
        hours = 12;
      }
    }

    let minutes = '';
    const minutesNum = date1.getMinutes();
    if (minutesNum < 10) {
      minutes = '0' + minutesNum.toString();
    } else {
      minutes = minutesNum.toString();
    }
    return Constants.monthNamesAbbreviated[date1.getMonth()] + ' ' + date1.getDate() + ', ' + date1.getFullYear() + ' ' + hours + ':' + minutes + ' ' + demarcation;
  }

  openNoteBuilder(dataNote: NoteDataModel) {
    const config = new MatDialogConfig();
    config.data = dataNote;
    config.panelClass = 'tdo-note-dialog-main';
    this.dialog.open(TdoNoteBuilderComponent, config).afterClosed().subscribe((data) => {
      if (data.length > 0) {
        dataNote.Note = data;
        this.notesService.saveDataNote(dataNote).subscribe((resp) => {
          dataNote = resp;

          let newNoteGroup = new NoteGroupDataModel();
          newNoteGroup.ObjectId = this.ObjectId;
          newNoteGroup.ParentObjectName = this.ParentObjectName;
          newNoteGroup.PatientId = this.PatientID;
          newNoteGroup.NoteId = dataNote.NoteId;

          this.notesService.saveNoteGroup(newNoteGroup).subscribe((gRes) => {
            newNoteGroup = gRes;
            newNoteGroup.dataNote = dataNote;

            // TODO: Handle saving

            // this.notes.unshift(newNoteGroup);
          });
        });
      }
    });
  }

  deleteNote(dataNote: NoteDataModel): void {
    this.dialogService.openConfirmDialog(`Are you sure you want to delete this note?`).subscribe((result) => {
      if (result === true) {
        dataNote.xauditDeleted = true;
        this.notesService.saveDataNote(dataNote).subscribe((resp) => {
          dataNote = resp;
          var noteIndex = this.filteredNotes.findIndex(note => note.NoteId === dataNote.NoteId);
          this.filteredNotes.splice(noteIndex, 1);
        });
      }
    });

  }

  openMacroNotes(dataNote: NoteDataModel) {
    const config = new MatDialogConfig();
    config.data = dataNote;
    config.panelClass = 'tdo-note-dialog-main';
    this.dialog.open(TdoMacroNotesComponent, config).afterClosed().subscribe((data) => {
      if (data.length > 0) {
        dataNote.Note += '\n' + data;
        this.notesService.saveDataNote(dataNote).subscribe((resp) => {
          dataNote = resp;

          let newNoteGroup = new NoteGroupDataModel();
          newNoteGroup.ObjectId = this.ObjectId;
          newNoteGroup.ParentObjectName = this.ParentObjectName;
          newNoteGroup.PatientId = this.PatientID;
          newNoteGroup.NoteId = dataNote.NoteId;

          this.notesService.saveNoteGroup(newNoteGroup).subscribe((gRes) => {
            newNoteGroup = gRes;
            newNoteGroup.dataNote = dataNote;

            // TODO: Handle saving
            // this.dataNoteGroups.unshift(newNoteGroup);
          });
        });
      }
    });
  }

  isNoteLocked(dataNote: NoteDataModel) {
    if (!dataNote) {
      return null;
    }

    const nowDate = new Date();
    const createdDate = new Date(dataNote.xauditCreatedOn);
    const msDiff = nowDate.getTime() - createdDate.getTime();

    // Num milliseconds in 24 hours 86400000
    return msDiff >= 86400000;
  }

  // Filter data
  ////////////////////////////////////////////////////////////////////////////////////////
  onFilterCategoryDropdownSelectionComplete(items: NoteCategoryDataModel[]) {
    if (items.length > 0) {
      this.storedNoteFilterSettings.notesCategories = items;
    } else {
      this.storedNoteFilterSettings.notesCategories = [this.allCategoryModel];
    }

    this.saveFilterSettings();
    this.filterNotes();
  }

  onFilterTypeDropdownSelectionComplete(items: NoteTypeDataModel[]) {
    if (items.length > 0) {
      this.storedNoteFilterSettings.notesTypes = items;
    } else {
      this.storedNoteFilterSettings.notesTypes = [this.allTypeModel];
    }

    this.saveFilterSettings();
    this.filterNotes();
  }

  onFilterCategorySettingsReset() {
    this.storedNoteFilterSettings.notesCategories = [this.allCategoryModel];
    this.categoryDropdown.clearCheckboxes();
    this.saveFilterSettings();
    this.filterNotes();
  }

  onFilterTypeSettingsReset() {
    this.storedNoteFilterSettings.notesTypes = [this.allTypeModel];
    this.typeDropdown.clearCheckboxes();
    this.saveFilterSettings();
    this.filterNotes();
  }

  onCheckboxChange(event: MatCheckboxChange) {
    switch (event.source.ariaLabel) {
      case 'Full View':
        this.storedNoteFilterSettings.isFullView = event.checked;
        if (!this.storedNoteFilterSettings.isFullView) {
          this.storedNoteFilterSettings.isCondensedView = true;
          /*this.storedNoteFilterSettings.isShowCreatedOn = false;
          this.storedNoteFilterSettings.isShowCreatedBy = false;
          this.storedNoteFilterSettings.isShowModifiedOn = false;
          this.storedNoteFilterSettings.isShowModifiedBy = false;*/
        } else {
          this.storedNoteFilterSettings.isCondensedView = false;
          /*this.storedNoteFilterSettings.isShowCreatedOn = true;
          this.storedNoteFilterSettings.isShowCreatedBy = true;
          this.storedNoteFilterSettings.isShowModifiedOn = true;
          this.storedNoteFilterSettings.isShowModifiedBy = true;*/
        }
        break;
      case 'Condensed View':
        this.storedNoteFilterSettings.isCondensedView = event.checked;
        if (!this.storedNoteFilterSettings.isCondensedView) {
          this.storedNoteFilterSettings.isFullView = true;
          /*this.storedNoteFilterSettings.isShowCreatedOn = true;
          this.storedNoteFilterSettings.isShowCreatedBy = true;
          this.storedNoteFilterSettings.isShowModifiedOn = true;
          this.storedNoteFilterSettings.isShowModifiedBy = true;*/
        } else {
          this.storedNoteFilterSettings.isFullView = false;
          /*this.storedNoteFilterSettings.isShowCreatedOn = false;
          this.storedNoteFilterSettings.isShowCreatedBy = false;
          this.storedNoteFilterSettings.isShowModifiedOn = false;
          this.storedNoteFilterSettings.isShowModifiedBy = false;*/
        }
        break;
      case 'Created On':
        this.isAllViewOptionsSelected();
        break;
      case 'Created By':
        this.isAllViewOptionsSelected();
        break;
      case 'Modified On':
        this.isAllViewOptionsSelected();
        break;
      case 'Modified By':
        this.isAllViewOptionsSelected();
        break;
    }

    this.saveFilterSettings();
  }

  isAllViewOptionsSelected() {
    if (this.storedNoteFilterSettings.isShowCreatedBy &&
      this.storedNoteFilterSettings.isShowCreatedOn &&
      this.storedNoteFilterSettings.isShowModifiedBy &&
      this.storedNoteFilterSettings.isShowModifiedOn) {
      // this.storedNoteFilterSettings.isFullView = true;
    } else {
      // this.storedNoteFilterSettings.isFullView = false;

      if (this.storedNoteFilterSettings.isShowCreatedBy === false ||
        this.storedNoteFilterSettings.isShowCreatedOn === false ||
        this.storedNoteFilterSettings.isShowModifiedBy === false ||
        this.storedNoteFilterSettings.isShowModifiedOn === false) {
        // this.storedNoteFilterSettings.isCondensedView = true;
      } else {
        // this.storedNoteFilterSettings.isCondensedView = false;
      }
    }
  }

  getBackgroundColor(note: NoteDataModel) {
    if (note && note.dataNoteTypes) {
      const alert = note.dataNoteTypes.find(p => p.enumNoteType.ItemDisplayValue.toLowerCase() === 'alert');
      if (alert) {
        return 'rgba(255,0,0,1)';
      } else {
        return 'none';
      }
    } else {
      return 'none';
    }
  }

  getTextColor(note: NoteDataModel) {
    if (note && note.dataNoteTypes) {
      const alert = note.dataNoteTypes.find(p => p.enumNoteType.ItemDisplayValue.toLowerCase() === 'alert');
      if (alert) {
        return 'white';
      } else {
        return 'black';
      }
    } else {
      return 'none';
    }
  }

  private handleRouteChange(data: NavigationStart) {
    const model = new TdoNoteQueryModel();
    model.patientId = this.patientId;
    // model.objectId = this.patientCaseId;
    // this.getNotes(model);
  }

  onExpandNotes() {
    this.uiService.openNotesWindow();
  }

  getTeethString(case1: PatientCaseViewDataModel) {
    return case1.Teeth;
  }

  getSelectedCase() {
    let ret: PatientCaseViewDataModel = null;
    if (this.cases && this.cases.length > 0) {
      ret = this.cases.find(p => p.PatientCaseId === this.currentCaseId);
    }

    return ret;
  }

  onCaseChange(event: MatSelectChange) {
    this.currentCaseId = event.value.PatientCaseId;
    const model = new TdoNoteQueryModel();
    model.patientId = this.patientId;
    if (this.currentCaseId !== '*') {
      model.objectId = this.currentCaseId;
    }
    this.getNotes(model);
  }

  onCasesSelectionChange($event: any) {
    const model = new TdoNoteQueryModel();
    model.patientId = this.patientId;
    this.currentCaseId = this.globals.currentPatientCaseId;

    if ($event) {
      // all cases
      this.getNotes(model);
    }
    else {
      // current case only
      model.objectId = this.currentCaseId;
      this.getNotesForPatientCase();
    }
  }
}
